// extracted by mini-css-extract-plugin
export var center = "RichTextPressQuote-module--center--124bf";
export var root = "RichTextPressQuote-module--root--52e9a";